// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.

const initialState = {
  fetchGetHeaderPending: false,
  fetchGetHeaderError: null,
  fetchGetHeaderSuccess: null,
  fetchGetFooterPending: false,
  fetchGetFooterError: null,
  fetchGetFooterSuccess: null,
  fetchLoginPending: false,
  fetchLoginError: null,
  fetchLoginSuccess: {},
  fetchGetPhoneCodePending: false,
  fetchGetPhoneCodeError: null,
  fetchGetPhoneCodeSuccess: null,
  fetchRegisterPending: false,
  fetchRegisterError: null,
  fetchRegisterSuccess: null,
  fetchGetPhoneCodeByLoginPending: false,
  fetchGetPhoneCodeByLoginError: null,
  fetchGetPhoneCodeByLoginSuccess: null,
  fetchEditStuPwdPending: false,
  fetchEditStuPwdError: null,
  fetchEditStuPwdSuccess: null,
  fetchLoginByPhonePending: false,
  fetchLoginByPhoneError: null,
  fetchLoginByPhoneSuccess: null,
  fetchGetConfigurationPending: false,
  fetchGetConfigurationError: null,
  fetchGetConfigurationSuccess: null,
  fetchConfigInfoPending: false,
  fetchConfigInfoError: null,
  configInfo: {},
  fetchStudentBasicsPending: false,
  fetchStudentBasicsError: null,
  studentBasics: {},
  fetchGetShoppingCarPending: false,
  fetchGetShoppingCarError: null,
  fetchGetShoppingCarSuccess: localStorage.getItem('shoppingCartData') ? JSON.parse(localStorage.getItem('shoppingCartData')) : null,
  fetchGetShoppingCarTotal: localStorage.getItem('shoppingCartData') ? JSON.parse(localStorage.getItem('shoppingCartData')).length : 0,
  fetchPutInCartsPending: false,
  fetchPutInCartsError: null,
  fetchMoveOutCartsPending: false,
  fetchMoveOutCartsError: null,
  fetchMoveOutCartsSuccess: null,
  fetchLogoutPending: false,
  fetchLogoutError: null,
  fetchLogoutSuccess: null,
  fetchFeedbackPending: false,
  fetchFeedbackError: null,
  fetchGetSearchDataPending: false,
  fetchGetSearchDataError: null,
  fetchGetSearchDataSuccess: null,
  fetchGetSearchDataTotal: 0,
  fetchGetWebSitePending: false,
  fetchGetWebSiteError: null,
  fetchGetWebSiteSuccess: null,
  fetchGetAdDefaultPending: false,
  fetchGetAdDefaultError: null,
  fetchGetWeAppCodePending: false,
  fetchGetWeAppCodeError: null,
  fetchGetWeAppCodeSuccess: null,
  fetchGetTeacherListPending: false,
  fetchGetTeacherListError: null,
  fetchGetTeacherListSuccess: null,
  fetchGetTeacherListTotal: 0,
  fetchGetTeacherBannerPending: false,
  fetchGetTeacherBannerError: null,
  fetchGetTeacherBannerSuccess: null,
  fetchGetTeacherInfoPending: false,
  fetchGetTeacherInfoError: null,
  fetchGetTeacherInfoSuccess: null,
  fetchGetTeacherAnswerPending: false,
  fetchGetTeacherAnswerError: null,
  fetchGetTeacherAnswerSuccess: null,
  fetchGetTeacherAboutPending: false,
  fetchGetTeacherAboutError: null,
  fetchGetTeacherAboutSuccess: null,
  fetchGetDefaultWxImgPending: false,
  fetchGetDefaultWxImgError: null,
  fetchGetPublicAccountPending: false,
  fetchGetPublicAccountError: null,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/common/redux/initialState.js